import { atom } from 'jotai';
import { uploadFailureModalAtom } from '@/atoms/lot/uploadFailureModalAtoms';

// Delete Photos Modal State
export const showDeletePhotosModalAtom = atom<boolean>(false);

// Stores photos grouped by lot for deletion
// Each entry represents a lot and its photos to delete
export type DeletePhotosByLot = {
    lotGuid: string;
    lotNumber?: string;
    photoIds: string[];
};
export const deletePhotosByLotAtom = atom<DeletePhotosByLot[]>([]);

// Tracks how the delete confirmation was triggered (for analytics)
export type DeletePhotosTrigger = 'Lot Menu' | 'Context Menu';
export const deletePhotosTriggerAtom = atom<DeletePhotosTrigger | null>(null);

// Move Photos Modal State
export const showMovePhotosModalAtom = atom<boolean>(false);

// Download Photos Modal State
// Stores the lot GUID to download photos from (null = no download)
export const downloadLotGuidAtom = atom<string | null>(null);

// Derived atom to check if any modal is open (for ESC key handling)
export const anyModalOpenAtom = atom(
    (get) =>
        get(showDeletePhotosModalAtom) ||
        get(showMovePhotosModalAtom) ||
        get(downloadLotGuidAtom) !== null ||
        get(uploadFailureModalAtom).show
);
